function mainAddToCart(){
  /* QUICK ADD TO CART */
  /* Click button quick add - Open pop-up size */
  
  let quick_adds_size = document.querySelectorAll('.quick-add-size');
  let quick_adds_atc_drawer = document.querySelectorAll('.quick-add-atc-notif');
  let quick_adds_size_overlays = document.querySelectorAll('.quick-add-size-overlay');
  let quick_add_buttons = document.querySelectorAll('.quick-add__add-to-cart');
  let html = document.querySelector('html');
  quick_add_buttons.forEach(function (quick_add_button) {
    quick_add_button.addEventListener('click', function () {
      let product_item = quick_add_button.closest('.grid__item');
      let popup_size = product_item.querySelector('.quick-add-size');
      let popup_overlay = product_item.querySelector('.quick-add-size-overlay');
      popup_size.classList.add('display-quick-add'); // Add class active to pop-up 
      popup_size.classList.add('active'); // Add class active to pop-up    
      popup_overlay.classList.add('active'); //Add class active to overlay
      html.classList.add('noscroll');
      const announcementBar = document.getElementById('shopify-section-announcement-bar');
      announcementBar.style.zIndex = '1';
      const navBar = document.getElementById('shopify-section-header');
      navBar.style.zIndex = '1';
    });
  });
  
  // Close overlay and popup on click on the overlay
  quick_adds_size_overlays.forEach(function (quick_add_size_overlay) {
    quick_add_size_overlay.addEventListener('click', function () {
      let product_item = quick_add_size_overlay.closest('.grid__item');
      let popup_size = product_item.querySelector('.quick-add-size');
      let popup_notification = product_item.querySelector('.quick-add-atc-notif');
      popup_size.classList.remove('active');
      popup_notification.classList.remove('active');
      popup_size.classList.remove('display-quick-add')
      this.classList.remove('active');
      html.classList.remove('noscroll');
      const announcementBar = document.getElementById('shopify-section-announcement-bar');
      // announcementBar.style.zIndex = '30';
      const navBar = document.getElementById('shopify-section-header');
      navBar.style.zIndex = '30';
    });
  });
  
  // Close overlay and popup on click on the close button 
  quick_adds_size.forEach(function (quick_add_size) {
    let btn_close_popup = quick_add_size.querySelector('.quick-add-size__header-close');
    btn_close_popup.addEventListener('click', function () {
      let current_product = this.closest('.grid__item');
      let popup_overlay = current_product.querySelector('.quick-add-size-overlay');
      let popup_size = current_product.querySelector('.quick-add-size');
      popup_overlay.classList.remove('active');
      popup_size.classList.remove('active');
      html.classList.remove('noscroll');
      const announcementBar = document.getElementById('shopify-section-announcement-bar');
      // announcementBar.style.zIndex = '30';
      const navBar = document.getElementById('shopify-section-header');
      navBar.style.zIndex = '30';
    });
  });
  
  /* CLICK ON SIZE TO ADD PRODUCT ON CART */
  let sizes = document.querySelectorAll('.quick-add-size__size');
  sizes.forEach(function (size) {
    size.addEventListener('click', function () {
      // Don't add to cart when variant sold out
      if (size.classList.contains('sold-out')) {
        return;
      }
  
      // Display the loader
      let loader_container = this.closest('.quick-add-size');
      loader_container.classList.add('loading');
  
      // ADD TO CART
      let variant_id = this.getAttribute('data-variant-id');
      let formData = {
        'items': [{
          'id': variant_id,
          'quantity': 1
        }]
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => {
        response.json().then(json => {
          if(json.status !== undefined && json.status !== 200){
            let loader_container = this.closest('.quick-add-size');
            loader_container.classList.remove('loading');
            let error_span = this.querySelector('.quick-add-size__size-title-error');
            this.classList.add('sold-out')
            error_span.textContent = json.message
          } else {
            let item_added = json.items[0];
            let current_product = this.closest('.grid__item');
            let item_added_title = current_product.querySelector('.quick-add-atc-notif__product-added-title');
            let item_added_size = current_product.querySelector('.quick-add-atc-notif__product-added-size');
            let item_added_image = current_product.querySelector('.quick-add-atc-notif__product-added-image');
            let item_added_price = current_product.querySelector('.quick-add-atc-notif__product-added-original-price');
            item_added_image.setAttribute('src', item_added.image);
            item_added_title.innerHTML = item_added.product_title;
            item_added_size.innerHTML = item_added.variant_title;
            item_added_price.innerHTML = Shopify.formatMoney(item_added.price);
    
            // Remove the loader
            let loader_container = this.closest('.quick-add-size');
            loader_container.classList.remove('loading');
    
            // CLOSE THE SIZE POPUP AND OPEN NOTIFICATION POPUP
            // Close size popup
            let popup_size = current_product.querySelector('.quick-add-size');
            popup_size.classList.remove('active');
            
            const navBar = document.getElementById('shopify-section-header');
            navBar.style.zIndex = '30';
    
            // Open notification popup
            let popup_notification = current_product.querySelector('.quick-add-atc-notif');
            popup_notification.classList.add('display-quick-add'); 
            popup_notification.classList.add('active');
          }
        });
      }).catch(error => {
        console.error('Error:', error);
      });
    });
  });
  
  // Close notification popup on click on the close button
  quick_adds_atc_drawer.forEach(function (quick_add_atc_notif) {
    let btn_close_popup = quick_add_atc_notif.querySelector('.quick-add-atc-notif__header-close');
    btn_close_popup.addEventListener('click', function () {
      let current_product = this.closest('.grid__item');
      let popup_overlay = current_product.querySelector('.quick-add-size-overlay');
      let popup_notification = current_product.querySelector('.quick-add-atc-notif');
      popup_overlay.classList.remove('active');
      popup_notification.classList.remove('active');
      popup_notification.classList.remove('display-quick-add');
      html.classList.remove('noscroll');
    });
  });
  
  // Close popup product added to cart by clicking on button return shopping
  let btns_return_shopping = document.querySelectorAll('.quick-add__return-shopping');
  btns_return_shopping.forEach(function (btn_return_shopping) {
    btn_return_shopping.addEventListener('click', function () {
      let current_product = this.closest('.grid__item');
      let popup_product_added = current_product.querySelector('.quick-add-atc-notif');
      let popup_overlay = current_product.querySelector('.quick-add-size-overlay');
      let html = document.querySelector('html');
      popup_product_added.classList.remove('active');
      popup_overlay.classList.remove('active');
      html.classList.remove('noscroll');
    });
  });
  }
  mainAddToCart()
  